import React from 'react';
import { Select as AntdSelect } from 'antd';
import { PlusCircleFilled } from '@ant-design/icons';
import {ReactComponent as ArrowDownSvg} from 'assets/icons/arrow-down.svg';
import {ReactComponent as SelectClearSvg} from 'assets/icons/select-clear.svg';
import Button from '../Button';
import cn from 'classnames';
import classes from './Select.module.scss';

const ASelect = ({ onSearch, showSearch, onCreate, className, isSelectProduct, popupClassName, itemRound, ...props }) => {
  const [keywords, setKeywords] = React.useState('');

  return (
    <AntdSelect
      showSearch={showSearch}
      onSearch={
        showSearch
          ? (searchStr) => {
              setKeywords(searchStr);
              onSearch && onSearch(searchStr);
            }
          : null
      }
      optionFilterProp="children"
      filterOption={false}
      suffixIcon={<ArrowDownSvg />}
      notFoundContent={
        props.creatable &&
        !!keywords && (
          <Button
            onClick={() => {
              onCreate && onCreate(keywords);
              if (props.onChange) {
                props.onChange(keywords, {
                  value: keywords,
                  label: keywords,
                });
              }
            }}
            style={{ padding: 0 }}
            icon={<PlusCircleFilled></PlusCircleFilled>}
            type="link">
            Add {`"${keywords}"`}
          </Button>
        )
      }
      {...props}
      options={(props.options || [])
        .filter((option) => {
          return String(option?.label ?? '')
            .toLowerCase()
            .includes((keywords || '').toLowerCase());
        })
        .map((option) => {
          return {
            ...option,
            label: option.sub ? (
              <span className="i-option-has-sub">
                <span>{option.label}</span>
                <span>{option.sub}</span>
              </span>
            ) : (
              option.label
            ),
          };
        })}
      className={cn(
        classes.wrapper,
        {
          [classes.isSelectProduct]: isSelectProduct,
          [classes.itemRound]: itemRound,
        },
        className
      )}
      popupClassName={cn(classes.popup, popupClassName, {
        [classes.isSelectProduct]: isSelectProduct,
      })}></AntdSelect>
  );
};
export default ASelect;
